import { BigNumber } from "./entities/BigNumber";

import { store } from "./store/store";
 
/**
 * Add number 0 before the time, if this is necessary 
 * @param value - time(hours) 
 * @returns formatted time  
 * Example: 09 => 09:00, 11 => 11:00
 */
function getZero(value: number) {
    if (value === undefined){
        return('N/A');
    }

    if (value === -1){
        value = 23;
    }

    if (value > 9) {
        return (value + ":00");
    }
    else {
        return ("0" + value + ":00");
    }
}

/**
 * Add number 0 before the date(day), if this is necessary 
 * @param value - number of the day
 * @returns formated date
 * Example: 2 => 02, 11 => 11
 */
function getZeroDate(value: number) { //0=>09
    if (value) 
        return ('0'+value).substring(value.toString().length-1)
    else   
        return('N/A');
}

/**
 * Format the value, excluding not important 0
 * @param value just any value
 * @returns formated value without null
 * Example: 0.00 => 0
 */
function deleteMin(value: string){ // убирает нули
    if (value) 
        return +value
    else 
        return('N/A');
}

/**
 * Check the numbers on a rendered page(cut decimals and also check N/A value)
 * @param value just any number
 * @param decimals how much decimals are needed to stay
 * @returns formated output
 * Example: 0.1534 => 0.15, 5 => 5
 */
function checkedOutput(value: string, decimals?: number): string {
    if (isNaN(+value) || !isFinite(+value)) {
        return ("N/A");
    }

    value = fix_exponential(value);

    const splited = value.toString().split('.');
    let res: string;
    if (splited[1] === undefined){
        res = splited[0];
    }
    else {
        res = splited[0] + '.' + splited[1].substring(0, decimals || 2);
    }
    return res
}


/**
 * Cut decimals in value
 * @param value 
 * @param decimal the number of decimals to stay
 * Example: (5.3412) => 5.34; (5.66738, 1) -> 5.6
 * @returns 
 */
function cutDecimals(value: number, decimal?: number): number {
    const value_array = value.toString().split('.');
    if (value_array[1] === '00') return +value_array[0]
    if (value_array.length === 1) 
        return value;
    return +(value_array[0] + '.' + value_array[1].substring(0, decimal || 2)); 
}

function toFixed(value: number | string, digits?: number): string{
    const digitsAfterDot = digits || 2;
	if (typeof(value) === 'number'){
		value = value.toString();
	}
	let splitted = value.split('.');
	if (splitted[1]){
		for (let i=1; i<digitsAfterDot; i++){
			splitted[1] = splitted[1] + '0';
		}
	}
	let res; 
	splitted.length === 2 ? res = splitted[0] + '.' + splitted[1].substring(0, digitsAfterDot) : res = splitted[0];
	return res;
}

/**
 * Throw the 'e' letter(exponential)  
 * @param value 
 * @returns formated value
 */
function fix_exponential(value: string | number): string{
    let data = value.toString().split(/[eE]/);
    if (data.length === 1) return data[0];
  
    let z = '',
        sign = +value < 0 ? '-' : '',
        str = data[0].replace('.', ''),
        mag = Number(data[1]) + 1;
  
    if (mag < 0) {
        z = sign + '0.';
        while (mag++) z += '0';

        return z + str.replace(/^-/, '');
    }

    mag -= str.length;
    while (mag--) z += '0';

    return str + z;
}

/**
 * Disconnect app, if an user logged out
 * @param clearAppState - clear state in Redux
 * @param provider 
 */
export function disconnect(clearAppState: () => void, provider: any) {
    localStorage.removeItem('WEB3_CONNECT_CACHED_PROVIDER');
    clearAppState();
    if (localStorage.getItem('walletconnect') && provider && provider.disconnect) {
        provider.disconnect();
    }
}

/**
 * Get current time in list-format
 * @param tsTime time in ts format
 * @returns the array of 2 arguments - hour and minutes
 * Example: 1663558015 => [8,26]
 */
export function getCurrentTime(tsTime: number): number[] {
    let formatedTime = new Date(tsTime * 1000);
    const hour = +formatedTime.getUTCHours();
    const minutes= +formatedTime.getUTCMinutes();
    return [hour, minutes]
    // return {hour: hour, minutes: minutes}
}

export function getTotalPosition() {
    const { balances, params, periods } = store.getState().app;
    if (!periods)
        throw new Error('no periods')
    const lastPeriod = periods.at(-1);
    if (balances && params && lastPeriod) {
        const longBalanceFtok = balances.lt.mul(new BigNumber(lastPeriod.ltv_c));
        const shortBalanceFtok = balances.st.mul(new BigNumber(lastPeriod.stv_c));
        const totalPos = longBalanceFtok.sub(shortBalanceFtok)
                                .mul(new BigNumber(params.leverage))
                                .div(new BigNumber(lastPeriod.beg_price))
        return totalPos
    } 
}

export function checkInputValue(amount: string) {
    if (amount.endsWith('.')) {
        return amount.slice(0, -1)
    }

    return amount
}

export {getZero, checkedOutput as notNaNandInf, getZeroDate, deleteMin, cutDecimals, fix_exponential, toFixed};